{
  "title": "Abrechnung",
  "notVisibleTitle": "Abrechnung ist für Sie nicht sichtbar",
  "notVisibleBody": "Abonnementdetails sehen Mandanten-Administratoren und höher.",
  "loadError": "Abrechnung konnte nicht geladen werden",
  "notConnectedTitle": "Abrechnung ist nicht verbunden",
  "notConnectedBody": "Dieses Deployment hat keine Stripe-Zugangsdaten. Setzen Sie Stripe:SecretKey und mindestens eine Price-ID an der API, um Abonnements zu aktivieren.",
  "checkoutCompleteTitle": "Checkout abgeschlossen",
  "checkoutCompleteBody": "Warte auf Bestätigung des Abonnements durch Stripe…",
  "checkoutCompleteToast": "Checkout abgeschlossen. Stripe bestätigt das Abonnement.",
  "checkoutCancelledToast": "Checkout wurde abgebrochen. Es wurde nichts berechnet.",
  "noSubscriptionTitle": "Kein Abonnement",
  "noSubscriptionBody": "Dieser Mandant wird noch nicht abgerechnet. Ein Abonnement berechnet einen Sitz pro Postfach, das die Plattform stempelt.",
  "noSubscriptionConfirming": "Stripe bestätigt das Abonnement. Diese Seite aktualisiert sich von selbst, sobald es da ist.",
  "startSubscription": "Abonnement starten",
  "setupBilling": "Abrechnung einrichten",
  "subscription": "Abonnement",
  "plan": "Tarif",
  "seats": "Sitze",
  "billedSeats": "Abgerechnete Sitze",
  "liveSeats": "Aktuelle Sitze",
  "seatsValue": "abgerechnet {{billed}} / aktuell {{current}}",
  "outOfSync": "nicht synchron",
  "syncSeats": "Sitze synchronisieren",
  "seatsSynced": "Sitze synchronisiert: Abrechnung {{count}}.",
  "seatSyncFailed": "Sitz-Synchronisierung fehlgeschlagen.",
  "openPortal": "Kundenportal öffnen",
  "manageInStripe": "Abrechnung in Stripe verwalten",
  "portalOpenFailed": "Abrechnungsportal konnte nicht geöffnet werden.",
  "cancelAtPeriodEnd": "Zum Periodenende kündigen",
  "resume": "Fortsetzen",
  "resumeSubscription": "Abonnement fortsetzen",
  "collectionCard": "Karte — automatisch belastet",
  "collectionInvoice": "Rechnung — per E-Mail mit Zahlungsziel",
  "collectionInvoiceNet": "Rechnung — per E-Mail mit Zahlungsziel (netto {{days}} Tage)",
  "statusNone": "Kein Abonnement",
  "statusIncomplete": "Unvollständig",
  "statusExpired": "Abgelaufen",
  "statusTrialing": "Testphase",
  "statusActive": "Aktiv",
  "statusPastDue": "Überfällig",
  "statusCanceled": "Gekündigt",
  "statusUnpaid": "Unbezahlt",
  "statusPaused": "Pausiert",
  "setupTitle": "Abrechnung einrichten",
  "setupIntro": "Pakete folgen dem Exclaimer-Layout Starter / Standard / Pro. Ein Sitz pro Postfach, das dieser Mandant stempeln lässt — heute {{seats}}{{minimum}}; der Zähler wird nachts abgeglichen und Änderungen gelten auf der nächsten Rechnung.",
  "setupMinimumSuffix": ", abgerechnet zum Minimum von {{minimum}} Sitzen",
  "periodMonthly": "Monatlich",
  "periodAnnual": "Jährlich",
  "billedAnnually": "Jährliche Abrechnung",
  "billedAnnuallySave": "Jährliche Abrechnung ({{percent}} % sparen)",
  "billedMonthly": "Monatliche Abrechnung",
  "savePercent": "{{percent}} % sparen",
  "planSeatRate": "{{name}} ({{rate}}/Sitz/Monat)",
  "planStarter": "Starter",
  "planStandard": "Standard",
  "planPro": "Pro",
  "enterpriseAvailable": " Enterprise (individuelles Angebot) über den Vertrieb verfügbar.",
  "licensedBlocks": "Lizenziert in Blöcken ab {{minimum}} Sitzen — ein kleinerer Mandant wird für {{minimum}} abgerechnet. ",
  "noTrialReturning": "Dieser Mandant war schon abonniert, daher gilt keine Testphase.",
  "trialDays": "Die ersten {{days}} Tage kostenlos; die erste Rechnung kommt am Ende der Testphase.",
  "payByCard": "Per Karte zahlen",
  "invoiceCustomer": "Kunde per Rechnung",
  "methodCard": "Karte",
  "methodInvoice": "Rechnung",
  "methodCardHint": "Öffnet Stripe Checkout zur Kartenerfassung. Stripe belastet sie jede Periode; der Kunde verwaltet sie selbst.",
  "methodInvoiceHint": "Stripe sendet jede Periode eine Rechnung mit Zahlungsziel. Keine Karte wird erfasst.",
  "billingEmail": "Rechnungs-E-Mail",
  "billingEmailHint": "Wohin Stripe Rechnungen und Belege sendet.",
  "billingEmailPlaceholder": "buchhaltung@kunde.com.au",
  "invoiceDueDays": "Rechnungsfälligkeit (Tage)",
  "setupFailed": "Abrechnung konnte nicht eingerichtet werden",
  "continueToStripe": "Weiter zu Stripe",
  "createSubscription": "Abonnement erstellen",
  "subscriptionCreated": "Abonnement erstellt. Stripe sendet Rechnungen an {{email}}.",
  "cancelTitle": "Zum Periodenende kündigen",
  "cancelBody": "Das Abonnement bleibt bis zum Periodenende aktiv und verlängert sich dann nicht.",
  "cancelBodyDetailed": "Die Abrechnung endet am Ende der bezahlten Periode{{onDate}}. Signaturen werden bis dahin weiter gestempelt; heute gibt es weder Rückerstattung noch Belastung.",
  "cancelOnDate": " am {{date}}",
  "confirmCancel": "Kündigung bestätigen",
  "resumeBody": "Das Abonnement verlängert sich wieder normal.",
  "updateFailed": "Abonnement konnte nicht aktualisiert werden",
  "resumedToast": "Abonnement fortgesetzt.",
  "cancelScheduledToast": "Das Abonnement endet am Periodenende.",
  "paymentOverdueTitle": "Zahlung überfällig",
  "paymentOverdueBody": "Stripe konnte die letzte Rechnung nicht einziehen. Signaturen werden weiter gestempelt — nichts stoppt automatisch — aber das Konto braucht Aufmerksamkeit.",
  "scheduledCancelTitle": "Kündigung geplant",
  "scheduledCancelBody": "Dieses Abonnement endet am {{date}} und verlängert sich nicht.",
  "scheduledCancelFallbackDate": "dem Ende der aktuellen Periode",
  "billingLabel": "Abrechnung",
  "invoicesGoTo": "Rechnungen gehen an",
  "notSet": "Nicht gesetzt",
  "price": "Preis",
  "ends": "Endet",
  "renews": "Verlängert",
  "seatsLastSynced": "Sitze zuletzt synchronisiert",
  "manage": "Verwalten",
  "manageHint": "Karten, Rechnungen und Belege liegen bei Stripe. Sitze werden hier jede Nacht abgeglichen; eine Änderung wirkt auf der nächsten Rechnung, nicht mitten in dieser.",
  "mspOnlyHint": "Abonnement ändern oder kündigen übernimmt das OnBrand-Mail-Team."
}
